import { Controller } from "@hotwired/stimulus"

// Submits the associated form when the element value changes.
export default class extends Controller {
    submit() {
        this.element.form?.submit()
    }
}
